<template>
  <gg-card>
    <gg-card-header>
      Domain Change Instructions
    </gg-card-header>
    <gg-card-text>
      <p>
        Before the Primary Domain on your hosting account can be updated, the following requirements must be met:
      </p>
      <p>
        <ul>
          <li><strong>Domain Availability:</strong> The new domain must not exist on the GreenGeeks network. If you've already added the new domain please remove it before proceeding.</li>
          <li><strong>Domain Verification:</strong> The new domain must point to GreenGeeks' nameservers, or be verified via a TXT record at your DNS provider.</li>
        </ul>
      </p>
      <p>
        As part of the process, your hosting account's Primary Domain will be updated to the new domain name, along with any Email or FTP accounts.
      </p>
      <p>If you have an existing WordPress website, the Website and Home URLs will be automatically updated to the new domain along with the SSL
        certificate. Note that reissuing the new SSL Certificate takes a few minutes and you'll see SSL warning messages until this process finishes.</p>
      <p>
        <strong>To verify a new domain via TXT record:</strong>
      </p>
      <p>
        <ol>
          <li>Access your existing DNS provider for the new domain.</li>
          <li>Add this TXT record under the root domain (@): <strong><i>greengeeks-domain-ownership-verification</i></strong></li>
          <li>Allow some time for DNS propagation (usually 1-2 hours), then submit your request.</li>
        </ol>
      </p>
      <p><strong>Need help? <router-link :to="{ name: 'support_ticketnew', query: { d: 'Support', s: hosting.id, sbj: 'Domain Change Assistance' } }">Contact GreenGeeks Support.</router-link></strong></p>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChangeInstructions',
  computed: {
    ...mapGetters(['hosting'])
  }
}
</script>
